import { render, staticRenderFns } from "./card.vue?vue&type=template&id=a5a04ede&"
import script from "./card.vue?vue&type=script&lang=ts&setup=true&"
export * from "./card.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports